// extracted by mini-css-extract-plugin
export default {"icon":"User__icon-w98_Q","iconWarn":"User__iconWarn-HKb7l","button":"User__button-jcjx5","disabled":"User__disabled-v5Er1"};